





















import { Component, Mixins } from "vue-property-decorator";
import { CacheableComponent } from "../../../base/components/system";
import { ModelEditableMixin, TabContainableMixin } from "../../../base/components/system/mixins";
import { TabSelector } from "../../../base/components/system/selectors";
import { FormatStructureTranslationTool } from "./contents";

@Component({
  components: {
    TabSelector,
    CacheableComponent,
    FormatStructureTranslationTool,
  }
})
export default class FormatEditorDebugTool extends Mixins(ModelEditableMixin, TabContainableMixin) {
  static readonly Tabs: {[key: string]: any} = {
    translation: {
      name: "フォーマット変換",
      description: "編集中のフォーマットのエンティティと逆変換を行った結果を表示できます。",
    },
  };
  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly translationTab: any = FormatEditorDebugTool.Tabs.translation;

  mounted(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = [
      this.translationTab,
    ];
    this.selectedTab = this.translationTab;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }
}
